var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 520,
    height: 480,
    viewBox: "0 0 520 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sound",
    transform: "translate(-700)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    transform: "translate(700)",
    fill: "#1d1f31",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 520,
    height: 480,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 519,
    height: 479,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    transform: "translate(1020 120) rotate(-90)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 180,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 177,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-drc",
    transform: "translate(549 198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-2",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "DRC",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.864,
    y: 0
  }, "DRC"))), /*#__PURE__*/React.createElement("g", {
    id: "button-dimmer",
    transform: "translate(449 198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-3",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "DIMMER",
    transform: "translate(311 78)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -31.76,
    y: 0
  }, "DIMMER"))), /*#__PURE__*/React.createElement("g", {
    id: "button-3d-sound",
    transform: "translate(549 278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-4",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_3D_SOUND",
    "data-name": "3D SOUND",
    transform: "translate(311 70)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.768,
    y: 0
  }, "3D"), /*#__PURE__*/React.createElement("tspan", {
    x: -28.92,
    y: 16
  }, "SOUND"))), /*#__PURE__*/React.createElement("g", {
    id: "button-hdmi-audio",
    transform: "translate(549 358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-5",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HDMI_AUDIO",
    "data-name": "HDMI AUDIO",
    transform: "translate(311 70)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.928,
    y: 0
  }, "HDMI"), /*#__PURE__*/React.createElement("tspan", {
    x: -25.928,
    y: 16
  }, "AUDIO"))), /*#__PURE__*/React.createElement("g", {
    id: "button-s-vol",
    transform: "translate(449 278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-6",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "S._VOL",
    "data-name": "S. VOL",
    transform: "translate(311 70)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.84,
    y: 0
  }, "S."), /*#__PURE__*/React.createElement("tspan", {
    x: -16.016,
    y: 16
  }, "VOL"))), /*#__PURE__*/React.createElement("g", {
    id: "button-hdmi-anynet",
    transform: "translate(449 358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-7",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "HDMI_ANYNET",
    "data-name": "HDMI ANYNET",
    transform: "translate(311 70)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.928,
    y: 0
  }, "HDMI"), /*#__PURE__*/React.createElement("tspan", {
    x: -32.12,
    y: 16
  }, "ANYNET"))), /*#__PURE__*/React.createElement("g", {
    id: "button-auto-power",
    transform: "translate(449 118)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-8",
    "data-name": "Rectangle 2",
    transform: "translate(271 42)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 57,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "AUTO_POWER",
    "data-name": "AUTO POWER",
    transform: "translate(311 70)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.32,
    y: 0
  }, "AUTO"), /*#__PURE__*/React.createElement("tspan", {
    x: -30.248,
    y: 16
  }, "POWER"))), /*#__PURE__*/React.createElement("g", {
    id: "button-power",
    transform: "translate(700 20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(20 20)",
    fill: "#970303",
    stroke: "#440101",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 38.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "power-off-solid",
    d: "M46.889,5.367a24.6,24.6,0,1,1-28.591.01,2.388,2.388,0,0,1,3.472.764l1.567,2.788A2.38,2.38,0,0,1,22.682,12a16.665,16.665,0,1,0,19.831-.01,2.367,2.367,0,0,1-.645-3.065l1.567-2.788a2.378,2.378,0,0,1,3.452-.774ZM36.571,26.19V2.381A2.375,2.375,0,0,0,34.19,0H31.016a2.375,2.375,0,0,0-2.381,2.381V26.19a2.375,2.375,0,0,0,2.381,2.381H34.19A2.375,2.375,0,0,0,36.571,26.19Z",
    transform: "translate(27 35)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-input-left",
    transform: "translate(689 359) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-9",
    "data-name": "Rectangle 2",
    transform: "translate(239 331)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1",
    "data-name": "Polygon 1",
    transform: "translate(258 346)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.18190383911133 39.5 L 0.8180956244468689 39.5 L 20.5 1.096284151077271 L 40.18190383911133 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 2.192539215087891 L 1.636177062988281 39 L 39.36382293701172 39 L 20.5 2.192539215087891 M 20.5 0 L 41 40 L 0 40 L 20.5 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "button-input-right",
    transform: "translate(1531 -199) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-10",
    "data-name": "Rectangle 2",
    transform: "translate(239 331)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1-2",
    "data-name": "Polygon 1",
    transform: "translate(259 346)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.18190383911133 39.5 L 0.8180956244468689 39.5 L 20.5 1.096284151077271 L 40.18190383911133 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 2.192539215087891 L 1.636177062988281 39 L 39.36382293701172 39 L 20.5 2.192539215087891 M 20.5 0 L 41 40 L 0 40 L 20.5 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    transform: "translate(1200 340) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 180,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 177,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    transform: "translate(1100 340) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 180,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 177,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    transform: "translate(1000 340) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 180,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 177,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-mute",
    transform: "translate(810 100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-11",
    "data-name": "Rectangle 2",
    transform: "translate(390 340) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "volume-mute-solid",
    d: "M21,64.692,12.31,73.379H2.344A2.343,2.343,0,0,0,0,75.722V89.785a2.344,2.344,0,0,0,2.344,2.344H12.31L21,100.815a2.345,2.345,0,0,0,4-1.657V66.349A2.345,2.345,0,0,0,21,64.692ZM45.082,82.754,49.539,78.3a1.576,1.576,0,0,0,0-2.228L47.31,73.84a1.576,1.576,0,0,0-2.228,0L40.625,78.3,36.168,73.84a1.576,1.576,0,0,0-2.228,0l-2.228,2.229a1.576,1.576,0,0,0,0,2.228l4.457,4.457L31.712,87.21a1.576,1.576,0,0,0,0,2.229l2.228,2.228a1.576,1.576,0,0,0,2.228,0l4.456-4.456,4.457,4.457a1.576,1.576,0,0,0,2.228,0l2.228-2.229a1.576,1.576,0,0,0,0-2.228Z",
    transform: "translate(325 216.996)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-vol-up",
    transform: "translate(720 -100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-12",
    "data-name": "Rectangle 2",
    transform: "translate(480 340) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "volume-up-solid",
    d: "M17.919,20.583,10.505,28H2a2,2,0,0,0-2,2V42a2,2,0,0,0,2,2h8.505l7.414,7.413a2,2,0,0,0,3.414-1.414V22A2,2,0,0,0,17.919,20.583Zm19.443-4.257A2.017,2.017,0,1,0,35.149,19.7a19.471,19.471,0,0,1,0,32.6,2.016,2.016,0,1,0,2.213,3.371,23.5,23.5,0,0,0,0-39.339ZM40,36a15.386,15.386,0,0,0-7.147-13.02,1.991,1.991,0,0,0-2.76.622,2.024,2.024,0,0,0,.618,2.78,11.389,11.389,0,0,1,0,19.237,2.023,2.023,0,0,0-.618,2.78,2,2,0,0,0,2.76.622A15.385,15.385,0,0,0,40,36ZM28.186,29.59a2,2,0,0,0-1.93,3.505,3.285,3.285,0,0,1,0,5.8,2,2,0,0,0,1.93,3.505,7.286,7.286,0,0,0,0-12.812Z",
    transform: "translate(416 264.005)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-vol-down",
    transform: "translate(720 -100)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-13",
    "data-name": "Rectangle 2",
    transform: "translate(480 440) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "volume-down-solid",
    d: "M19.6,65.641,11.49,73.749h-9.3A2.187,2.187,0,0,0,0,75.936V89.061a2.187,2.187,0,0,0,2.187,2.187h9.3L19.6,99.356a2.189,2.189,0,0,0,3.734-1.547V67.188A2.189,2.189,0,0,0,19.6,65.641Zm11.229,9.851a2.188,2.188,0,1,0-2.111,3.833,3.593,3.593,0,0,1,0,6.346A2.188,2.188,0,1,0,30.828,89.5a7.97,7.97,0,0,0,0-14.013Z",
    transform: "translate(423 318.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-sw-level-minus",
    transform: "translate(1000 -120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-14",
    "data-name": "Rectangle 2",
    transform: "translate(100 460) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "minus-solid",
    d: "M44.571,208H3.429A3.429,3.429,0,0,0,0,211.429v3.429a3.429,3.429,0,0,0,3.429,3.429H44.571A3.429,3.429,0,0,0,48,214.857v-3.429A3.429,3.429,0,0,0,44.571,208Z",
    transform: "translate(36 207)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-av-sync-minus",
    transform: "translate(900 -120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-15",
    "data-name": "Rectangle 2",
    transform: "translate(100 460) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "minus-solid-2",
    "data-name": "minus-solid",
    d: "M44.571,208H3.429A3.429,3.429,0,0,0,0,211.429v3.429a3.429,3.429,0,0,0,3.429,3.429H44.571A3.429,3.429,0,0,0,48,214.857v-3.429A3.429,3.429,0,0,0,44.571,208Z",
    transform: "translate(36 207)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-sw-level-plus",
    transform: "translate(1000 -120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-16",
    "data-name": "Rectangle 2",
    transform: "translate(100 360) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "plus-solid",
    d: "M44.571,50.857H29.143V35.429A3.429,3.429,0,0,0,25.714,32H22.286a3.429,3.429,0,0,0-3.429,3.429V50.857H3.429A3.429,3.429,0,0,0,0,54.286v3.429a3.429,3.429,0,0,0,3.429,3.429H18.857V76.571A3.429,3.429,0,0,0,22.286,80h3.429a3.429,3.429,0,0,0,3.429-3.429V61.143H44.571A3.429,3.429,0,0,0,48,57.714V54.286A3.429,3.429,0,0,0,44.571,50.857Z",
    transform: "translate(36 264)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-av-sync-plus",
    transform: "translate(900 -120)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-17",
    "data-name": "Rectangle 2",
    transform: "translate(100 360) rotate(180)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "plus-solid-2",
    "data-name": "plus-solid",
    d: "M44.571,50.857H29.143V35.429A3.429,3.429,0,0,0,25.714,32H22.286a3.429,3.429,0,0,0-3.429,3.429V50.857H3.429A3.429,3.429,0,0,0,0,54.286v3.429a3.429,3.429,0,0,0,3.429,3.429H18.857V76.571A3.429,3.429,0,0,0,22.286,80h3.429a3.429,3.429,0,0,0,3.429-3.429V61.143H44.571A3.429,3.429,0,0,0,48,57.714V54.286A3.429,3.429,0,0,0,44.571,50.857Z",
    transform: "translate(36 264)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "INPUT",
    transform: "translate(1110 33)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.96,
    y: 0
  }, "INPUT")), /*#__PURE__*/React.createElement("text", {
    id: "VOL",
    transform: "translate(1160 153)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.016,
    y: 0
  }, "VOL")), /*#__PURE__*/React.createElement("text", {
    id: "SW_LEVEL",
    "data-name": "SW LEVEL",
    transform: "translate(1060 153)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -39.568,
    y: 0
  }, "SW LEVEL")), /*#__PURE__*/React.createElement("text", {
    id: "AV_SYNC",
    "data-name": "AV SYNC",
    transform: "translate(960 153)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -34.2,
    y: 0
  }, "AV SYNC")), /*#__PURE__*/React.createElement("text", {
    id: "SOUND-2",
    "data-name": "SOUND",
    transform: "translate(760 33)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28.92,
    y: 0
  }, "SOUND")), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    transform: "translate(820 120) rotate(-90)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 180,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 177,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "button-sound-mode-left",
    transform: "translate(489 359) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-18",
    "data-name": "Rectangle 2",
    transform: "translate(239 331)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1-3",
    "data-name": "Polygon 1",
    transform: "translate(258 346)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.18190383911133 39.5 L 0.8180956244468689 39.5 L 20.5 1.096284151077271 L 40.18190383911133 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 2.192539215087891 L 1.636177062988281 39 L 39.36382293701172 39 L 20.5 2.192539215087891 M 20.5 0 L 41 40 L 0 40 L 20.5 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "button-sound-mode-right",
    transform: "translate(1331 -199) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2-19",
    "data-name": "Rectangle 2",
    transform: "translate(239 331)",
    fill: "#324357",
    stroke: "#0a0d10",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 77,
    height: 77,
    rx: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Polygon_1-4",
    "data-name": "Polygon 1",
    transform: "translate(259 346)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 40.18190383911133 39.5 L 0.8180956244468689 39.5 L 20.5 1.096284151077271 L 40.18190383911133 39.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 20.5 2.192539215087891 L 1.636177062988281 39 L 39.36382293701172 39 L 20.5 2.192539215087891 M 20.5 0 L 41 40 L 0 40 L 20.5 0 Z",
    stroke: "none",
    fill: "#707070"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "SOUND_MODE",
    "data-name": "SOUND MODE",
    transform: "translate(910 33)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "NunitoSans-SemiBold, Nunito Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -54.576,
    y: 0
  }, "SOUND MODE")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.ba03600cfe0de0fb0c38601799488449.svg";
export { ForwardRef as ReactComponent };